export default __webpack_public_path__ + "static/media/Belt of Intricate Spite.d866f7b9.jpg";